<template>
  <Textarea :rows="5" v-model="local" @blur="normalize" />
</template>

<script>
import { Textarea } from "@/shared/ui/textarea";

export default {
  components: { Textarea },
  props: ["item"],
  data() {
    return {
      local: JSON.stringify(this.item.value ?? {}, null, 2),
    };
  },
  methods: {
    normalize() {
      try {
        const parsed = JSON.parse(this.local);
        this.$emit("update", this.item.key, parsed);
      } catch (e) {
        // можно показать ошибку
      }
    },
  },
};
</script>
